document.addEventListener('DOMContentLoaded', () => {
    const toggleButtons = document.querySelectorAll('.app-faqs .collapsible-content__toggle');
    const answerContents = document.querySelectorAll('.app-faqs .collapsible-content__answer');

    toggleButtons.forEach((toggleButton, index) => {
        toggleButton.addEventListener('click', () => {
            answerContents.forEach((answerContent, i) => {
                if (i === index) {
                    return;
                }
                answerContent.classList.remove('active');
                toggleButtons[i].querySelector('.app-faqs .plus').style.display = 'block';
                toggleButtons[i].querySelector('.app-faqs .minus').style.display = 'none';
            });

            answerContents[index].classList.toggle('active');

            const plusIcon = toggleButton.querySelector('.app-faqs .plus');
            const minusIcon = toggleButton.querySelector('.app-faqs .minus');

            plusIcon.style.display = answerContents[index].classList.contains('active') ? 'none' : 'block';
            minusIcon.style.display = answerContents[index].classList.contains('active') ? 'block' : 'none';
        });
    });
});